import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { SearchableDropdownField } from 'ui-components/components/dropdown';

import messages from './messages';
import Global from '../../../../../../../../store/global-selectors';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from '../style.module.less';

/**
 * @typedef {import('../../../../../types/automation-rule-types.d.ts').AutomationRuleActionInputValueProps} AutomationRuleActionInputValueProps
 */

const getOptionLabel = (option) => option.name;
const getOptionValue = (option) => option.userId;

/**
 * @param {object} props
 * @param {AutomationRuleActionInputValueProps} props.inputValueProps
 * @param {(updatedProps: AutomationRuleActionInputValueProps) => void} props.onChange
 * @param {ReactNode} props.label
 * @returns {JSX.Element}
 */
export const UserSearchableDropdown = ({ inputValueProps, onChange, label }) => {
  const users = useSelector(Global.selectSellerUsers);

  const intl = useIntl();

  const options = useMemo(() => {
    return users.filter((user) => user.isActive).sort((a, b) => a.name.localeCompare(b.name));
  }, [users]);

  const updateSelectedUser = useCallback(
    (value) => {
      onChange({
        [PARAMETER]: value,
      });
    },
    [onChange],
  );

  const selectedUserId = inputValueProps[PARAMETER];
  const placeholder = intl.formatMessage(messages.noOptionSelectedMessage);

  return (
    <div className={style['action-selector']}>
      <div>{label}</div>
      <SearchableDropdownField
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        onItemSelected={updateSelectedUser}
        options={options}
        placeholder={placeholder}
        selectedItemValue={selectedUserId}
      />
    </div>
  );
};
